import { render, staticRenderFns } from "./bankMovementCreateModal.vue?vue&type=template&id=3475bf70&"
import script from "./bankMovementCreateModal.vue?vue&type=script&lang=ts&"
export * from "./bankMovementCreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./bankMovementCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports